"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const helpers_1 = require("evolution-common/lib/utils/helpers");
// Section Progress Bar Component to show the completion percentage of the survey and the section title
const SectionProgressBar = ({ title, interview, sectionName, sections }) => {
    const { t, i18n } = (0, react_i18next_1.useTranslation)();
    // Calculate the survey completion percentage based on the number of completed sections
    const completionPercentage = (0, helpers_1.calculateSurveyCompletionPercentage)({
        interview,
        sections,
        sectionName,
        sectionTarget: 'currentSection'
    });
    // Circular progress bar properties
    const radius = 45; // Adjusted radius to fit within 100px diameter
    const strokeWidth = 10; // Adjusted stroke width
    const circumference = 2 * Math.PI * radius; // Circumference of the circle
    const offset = circumference - (completionPercentage / 100) * circumference; // Stroke offset for progress
    return (react_1.default.createElement("div", { className: "survey-section__progress-bar" },
        react_1.default.createElement("div", { className: "big-text" },
            (0, helpers_1.translateString)(title, i18n, interview, sectionName),
            " - Section"),
        react_1.default.createElement("svg", { width: "100", height: "100", viewBox: "0 0 100 100", className: "circular-progress" },
            react_1.default.createElement("circle", { className: "bg", cx: "50", cy: "50", r: radius, strokeWidth: strokeWidth }),
            react_1.default.createElement("circle", { className: "fg", cx: "50", cy: "50", r: radius, strokeWidth: strokeWidth, strokeDasharray: circumference, strokeDashoffset: offset }),
            react_1.default.createElement("text", { x: "50", y: "45", textAnchor: "middle", className: "percentage-text" },
                completionPercentage,
                "%"),
            react_1.default.createElement("text", { x: "50", y: "60", textAnchor: "middle", className: "completed-text" }, t('survey:completed')))));
};
exports.default = SectionProgressBar;
//# sourceMappingURL=SectionProgressBar.js.map